"use client";

import { PageWrapper } from "@/components/core";
import { StakeTabs } from "@/components/features/staking/StakeTabs";

const Page = () => {
  return (
    <PageWrapper>
      <StakeTabs />
    </PageWrapper>
  );
};

export default Page;
